module.exports = __webpack_public_path__ + "static/media/04.c2b364d7.mp3";